import React, { useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import NegotiationState from '../../../_shared/constants/negotiationState';
import PendingListCardVariant from '../../../_shared/constants/pendingListCardVariant';
import CardHighlight from '../CardHighlight';
import PendingTradeCardContent from '../PendingTradeCardContent';
import NegotiationCardFooter from './NegotiationCardFooter';
import { TradeCard } from './Styles';
import ReducerConstants from '../../../_shared/constants/reducers';

const PendingNegotiationCard = ({
  trade,
  testId,
  tradeContext,
  isOmp = false,
  handleNavigateToTradeUri
}) => {
  const { negotiationOffer, negotiationState, isGreyOut } = trade;
  const showHighlight =
    !isGreyOut && negotiationState === NegotiationState.FINAL_ASKING_PRICE;
  const [isAuctionEnded, setIsAuctionEnded] = useState(trade?.isGreyOut);
  const negotiationChange = useSelector(
    state => state[ReducerConstants.NEGOTIATION_CHANGE]?.[trade.id],
    shallowEqual
  );

  // Updates the trade details data with the negotiation SSE update
  const updatedTrade = useMemo(() => {
    const newOffer = negotiationChange?.proposedAmount ?? negotiationOffer;
    const buyerOrSellerCounter = negotiationChange?.buyerToSeller
      ? NegotiationState.BUYER_COUNTER
      : NegotiationState.SELLER_COUNTER;
    const newState =
      typeof negotiationChange?.buyerToSeller === 'boolean'
        ? buyerOrSellerCounter
        : negotiationState;

    return {
      ...trade,
      negotiationOffer: newOffer,
      negotiationState: newState
    };
  }, [
    negotiationChange?.buyerToSeller,
    negotiationChange?.proposedAmount,
    negotiationOffer,
    negotiationState,
    trade
  ]);

  return (
    <TradeCard>
      <PendingTradeCardContent
        testId={testId}
        tradeSummary={updatedTrade}
        isAuctionEnded={isGreyOut}
        listCardVariant={PendingListCardVariant.NEGOTIATION}
        onAuctionEnded={() => {
          setIsAuctionEnded(true);
        }}
        tradeContext={tradeContext}
        isOmp={isOmp}
        handleNavigateToTradeUri={handleNavigateToTradeUri}
      />
      <NegotiationCardFooter
        trade={updatedTrade}
        testId={`${testId}-footer`}
        tradeContext={tradeContext}
        disableActionButtons={isAuctionEnded}
        isOmp={isOmp}
        handleNavigateToTradeUri={handleNavigateToTradeUri}
      />
      {showHighlight && <CardHighlight />}
    </TradeCard>
  );
};

export default PendingNegotiationCard;
